import React, { useState, useEffect } from 'react';
import User from 'utils/user.util';
import { useTranslation } from 'react-i18next';

const Reports = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);
    const [reportsURL, setReportsURL] = useState('');

    useEffect(() => {
        let mounted = true;
        const fetchURL = async () => {
            try {
                const token = User.getToken();
                const response = await fetch(
                    `${process.env.REACT_APP_PROXY_URL || ''}/api/reports/url`,
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
                if (!response.ok) throw new Error(`Fetch failed: ${response.status}`);
                const data = await response.json();
                if (mounted) {
                    setReportsURL(data.url || '');
                    setLoading(false);
                }
            } catch (err) {
                console.error(err);
                if (mounted) setLoading(false);
            }
        };
        fetchURL();
        return () => {
            mounted = false;
        };
    }, []);

    return (
        <div style={{ minHeight: '1200px', display: 'flex', flexDirection: 'column' }}>
            <h1>Reports</h1>
            {(loading || reportsURL === '') && (
                <div
                    style={{
                        flex: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    {loading && <p>Loading...</p>}
                    {!loading && reportsURL === '' && (
                        <p style={{ margin: 0, textAlign: 'center' }}>
                            {t('reporting_unavailable')}
                        </p>
                    )}
                </div>
            )}
            {!loading && reportsURL !== '' && (
                <iframe
                    width="100%"
                    height="100%"
                    src={reportsURL}
                    frameBorder="0"
                    style={{ flex: 1, border: 0 }}
                    allowFullScreen
                    sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-downloads allow-top-navigation-by-user-activation"
                ></iframe>
            )}
        </div>
    );
};

export default Reports;
